import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../service/auth.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-logout-dialog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.scss'
})
export class LogoutDialogComponent {
  constructor(private dialogRef: MatDialogRef<LogoutDialogComponent>, private authService:AuthService){}

  onConfirm(){
    this.authService.logout();
    this.dialogRef.close(true);
  }
  onCancel(){
    this.dialogRef.close(false);
  }
}
